import { Button } from '@talentmesh/ui/components/button';
import { Spinner } from '@talentmesh/ui/components/spinner';
import { Timer } from 'lucide-react';
import TestInfo from '../../../../../../../../../Models/TestInfo';
import UIStrings from '@/Utils/UIStrings';

export interface BaseTestCardDurationProps extends Pick<TestInfo, 'duration'> {
    toggleDialog: () => void;
    isPreviewQuestionsLoading: boolean;
}

function BaseTestCardDuration({ duration, toggleDialog, isPreviewQuestionsLoading }: BaseTestCardDurationProps) {
    return (
        <div className="flex flex-row gap-4">
            <div className="flex w-full flex-row justify-between gap-2">
                <div className="text-foreground flex flex-row items-center gap-1.5">
                    <Timer className="mb-1 size-4 shrink-0 text-sm" aria-hidden />
                    <span className="text-sm">{`${duration} ${UIStrings.ShortMinute}`}</span>
                </div>
                <Button
                    type="button"
                    variant="default-outline"
                    size="sm"
                    disabled={isPreviewQuestionsLoading}
                    onClick={(e) => {
                        e.stopPropagation();
                        toggleDialog();
                    }}
                    className="shrink-0 bg-transparent"
                >
                    {isPreviewQuestionsLoading && <Spinner className="mr-2 size-4" />}
                    {UIStrings.PreviewQuestions}
                </Button>
            </div>
        </div>
    );
}

export default BaseTestCardDuration;
